import { PriceSummary } from "./PriceSummary";
import type { SinglePriceSummaryProps } from "./types";

export const SinglePriceSummary = ({ priceModel }: SinglePriceSummaryProps) => {
  const {
    installmentCount,
    installmentAmount,
    totalPaymentAmount,
    downpaymentAmount,
  } = priceModel;

  return (
    <PriceSummary
      downpayment={installmentCount ? downpaymentAmount : totalPaymentAmount}
      installments={
        installmentCount
          ? [
              {
                label: `${installmentCount} Monthly payments of`,
                value: installmentAmount,
              },
            ]
          : []
      }
      total={totalPaymentAmount}
    />
  );
};

SinglePriceSummary.displayName = "SinglePriceSummary";
